import { boolean, schema } from "@anna-money/anna-web-lib/serializer";

export class CheckStripeRequirementsResponseData extends schema(
  {
    ready: boolean(),
  },
  "CheckStripeRequirementsResponseData",
) {}
